<template>
    <form :action="action" ref="form" class="searchform">
        <input type="text" name="s" ref="query" autocomplete="off" @focusout="isFocus = false" @focus="isFocus = true"
               v-model.trim="query" @keydown="search(query)"
               :placeholder="placeholderLang">
        <button name="rechercher" type="submit" aria-label="Rechercher"></button>

        <div :class="{show: showLastQueries}" id="lastQueries">
            <div class="empty-wrapper">
                <span class="last-title">{{ lastSearch }}</span>
                <a href="javascript:;" @click="clearLastQueries" class="last-empty">{{ clearHistory }}</a>
            </div>
            <ul class="last-list">
                <li v-for="lastQuery in lastQueries" @click="submitLastQuery(lastQuery)">
                    <a :href="action + '/?s=' + lastQuery" tabindex="0">{{ lastQuery }}</a>
                </li>
            </ul>
        </div>

        <div id="searchFormResults" v-if="posts.length>0">
            <ul>
                <li v-for="post in posts" @click="window.location.href = post.url">
                    <figure class="search-img">
                        <picture>
                            <img :src="post['_embedded']['self'][0]['thumbnail']" width="50px" height="50px" alt="">
                        </picture>
                    </figure>
                    <a :href="post.url" :title="post.title" tabindex="0">{{ post.title }}</a>
                </li>
            </ul>
        </div>
    </form>

    <div id="searchLoading" v-if="isLoading">
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>

</template>

<script>

export default {
    name: "SearchForm",
    props: ['action', 'api', 'lastQueriesKey', 'placeholderLang', 'lastSearch', 'clearHistory'],
    data() {
        return {
            isLoading: false,
            isFocus: false,
            query: "",
            lastQueries: [],
            posts: [],
            debounce: null,
        }
    },
    mounted() {
        // Get last queries from local storage
        if (localStorage.getItem(this.lastQueriesKey)) {
            this.lastQueries = JSON.parse(localStorage.getItem(this.lastQueriesKey))
        }
    },
    computed: {
        showLastQueries() {
            return this.isFocus && this.lastQueries.length > 0 && this.posts.length === 0 && !this.isLoading;
        },
        slugifiedQuery() {
            return this.slugify(this.query);
        }
    },
    methods: {
        // Post form with normal wordpress submission
        submitLastQuery(lastQuery) {
            this.$refs.query.value = lastQuery;
            this.$refs.form.submit();
        },
        // Slugify function
        slugify(str) {
            return str
                .toString()                   // Cast to string (optional)
                .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
                .toLowerCase()                // Convert the string to lowercase letters
                .trim()                       // Remove whitespace from both sides of a string (optional)
                .replace(/\s+/g, '-')         // Replace spaces with -
                .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
                .replace(/\_/g, '-')           // Replace _ with -
                .replace(/\-\-+/g, '-')       // Replace multiple - with single -
                .replace(/\-$/g, '');         // Remove trailing -
        },
        // Search after 350 ms
        search() {
            let vm = this;
            vm.$nextTick(() => {
                clearTimeout(vm.debounce);
                vm.debounce = setTimeout(vm.doQuery, 350);
            });
        },
        // Sort posts with best relevance
        sortByTitleRelevance(value1, value2) {
            let vm = this;
            const firstIndex1 = vm.slugify(value1.title).indexOf(vm.slugifiedQuery);
            const firstIndex2 = vm.slugify(value2.title).indexOf(vm.slugifiedQuery);
            if (firstIndex1 < firstIndex2) {
                return -1;
            }
            if (firstIndex1 > firstIndex2) {
                return 1;
            }
            return 0;
        },
        // Remove last queries from local storage
        clearLastQueries() {
            this.lastQueries = [];
            localStorage.setItem(this.lastQueriesKey, JSON.stringify(this.lastQueries));
        },
        // Store last 5 queries in local storage
        storeQuery() {
            let vm = this;
            if (!vm.lastQueries.includes(vm.query)) {
                vm.lastQueries.unshift(vm.query);
            }
            if (vm.lastQueries.length > 5) {
                vm.lastQueries.pop();
            }
            localStorage.setItem(this.lastQueriesKey, JSON.stringify(vm.lastQueries));
        },
        doQuery() {
            let vm = this;
            if (vm.query && vm.query.length >= 3) {
                vm.isLoading = true;
                vm.posts.splice(0);
                // Query wordpress api search
                fetch(`${vm.api}?search=${encodeURIComponent(vm.query)}&per_page=10&status=publish&subtype=post,page&_embed`, {
                    headers: {'Content-Type': 'text/plain; charset=UTF-8'}
                })
                    .then(response => response.json())
                    .then((response) => {
                        vm.isLoading = false;
                        // Remove posts which don't match title
                        response = response.filter((value, index, arr) => {
                            const titles = vm.slugify(vm.decode(value.title)).split('-');
                            const keywords = vm.slugifiedQuery.split('-');
                            return titles.some(r => keywords.some(el => {
                                if (r.length >= 3 && el.length >= 3) {
                                    return r.includes(el);
                                }
                                return false;
                            }));
                        });
                        // Sort them by relevance
                        response.sort(vm.sortByTitleRelevance);
                        // Store query in local storage
                        vm.storeQuery();

                        // fix encoding in post title
                        response = response.map(post => {
                            return {...post, title: vm.decode(post.title)};
                        });
                        vm.posts = response;
                    })
                    .catch(error => console.error(error));
            } else {
                vm.posts.splice(0);
            }
        },
        decode(str) {
            // Function to fix encoding from rest api
            let txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        }
    }
}
</script>

<style lang="scss">
@import "../../sass/5-layouts/searchform";
</style>
